import React from 'react'

import AuthLayout from '../../components/auth-layout'
import Logo from '../../components/logo'

export interface Props {
  children: React.ReactNode
}

const AuthLayoutPartial = ({children}: Props) => (
  <AuthLayout header={<Logo alt="Craftcloud®" invert />}>{children}</AuthLayout>
)

export default AuthLayoutPartial
